export var WalletName;
(function (WalletName) {
    WalletName["Bitpie"] = "Bitpie";
    WalletName["Blocto"] = "Blocto";
    // Clover = 'Clover',
    WalletName["Coin98"] = "Coin98";
    WalletName["Ledger"] = "Ledger";
    WalletName["MathWallet"] = "MathWallet";
    WalletName["Phantom"] = "Phantom";
    WalletName["SafePal"] = "SafePal";
    WalletName["Slope"] = "Slope";
    WalletName["Solflare"] = "Solflare";
    WalletName["SolflareWeb"] = "Solflare (Web)";
    WalletName["Sollet"] = "Sollet";
    WalletName["SolletExtension"] = "Sollet (Extension)";
    WalletName["Solong"] = "Solong";
    WalletName["Torus"] = "Torus";
    // WalletConnect = 'WalletConnect',
})(WalletName || (WalletName = {}));
//# sourceMappingURL=types.js.map